<div class="narrative-note-dialog-container" data-cy="narrative-note-dialog">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="narrative-note-section">
    <div class="section-header" style="flex-basis: 30px;" data-cy="narrative-note-header-section">
      <div class="section-header-title" data-cy="narrative-note-title">
        Claim Narratives
      </div>
    </div>
    <div class="section-content" style="flex: 1; text-align: left;" data-cy="narrative-note-content">

      <div data-cy="narrative-note-input-section">
        <span class="narrative-note-header" data-cy="narrative-note-input-header">Enter Narrative</span>
        <br>
        <textarea [(ngModel)]="this.noteText" style="width: 100%; height: 100px" data-cy="narrative-note-input"></textarea>
        <br>
        <div style="text-align: right" data-cy="narrative-note-save-container">
          <button (click)="onNarrativeOkClick()" class="tdo-button tdo-save" [disabled]="!this.noteText" style="margin-right: 6px;" data-cy="narrative-note-save-btn">Save Narrative</button>
        </div>
      </div>

      <div data-cy="narrative-note-existing-section">
        <span class="narrative-note-header" data-cy="narrative-note-existing-header">Existing Narratives</span>
        <br>
        <div *ngIf="attachments.length < 1" data-cy="narrative-note-no-data">
          No narratives exist for this claim.
        </div>
        <div *ngIf="attachments.length > 0" style="height: 260px; overflow: auto" data-cy="narrative-note-list-container">
          <div *ngFor="let narrative of this.attachments" style="margin-bottom: 10px" data-cy="narrative-note-item">
            <div style="border: 1px #000000 solid; padding:5px" data-cy="narrative-note-content-text">
              {{ narrative.Note }}
            </div>
            <div style="text-align: right" data-cy="narrative-note-actions">
              <div style="display: flex; flex-direction: row-reverse;" data-cy="narrative-note-actions-row">
                <div *ngIf="claimNarrativeNoteStatusCode(narrative) === 'added'" style="flex-basis: 25px; color: var(--tdo-secondary-accent); cursor: pointer;" matTooltip="Delete" (click)="deleteNarrativeNote(narrative)" data-cy="narrative-note-delete-btn">
                  <mat-icon data-cy="narrative-note-delete-icon">delete</mat-icon>
                </div>
                <div data-cy="narrative-note-status">
                  {{ claimNarrativeNoteStatus(narrative) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="section-footer" style="flex-basis: 60px; padding-top: 6px; text-align: right" data-cy="narrative-note-footer">
      <div style="flex: 1; margin-right: 6px; text-align: left" data-cy="narrative-note-fr-btn-container">
        <button (click)="onFRNoteClick()" class="tdo-button tdo-close" style="margin-left: 6px;" data-cy="narrative-note-fr-btn">Add From Final Report</button>
      </div>
      <div style="flex: 1; margin-right: 6px;" data-cy="narrative-note-spacer"></div>
      <button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="narrative-note-close-btn">Close</button>
    </div>
  </div>
</div>
